<ng-template [ngIf]="!!formViewData.formSpec && ((legacyWebUI && url3_5) || (uiCompare && url3_5))">
  <p *ngIf="unsupportedPattern && !isProduction" style="font-weight: bold; color:red; height: 20px;text-align: center; position:absolute; width:100%">
    CURRENTLY UNSUPPORTED SOHO XI PATTERN DETECTED
  </p>
  <lm-html-url-doc
    [url]="url3_5"
    [showLoading]="false"
    (titleChanged)="onTitleChanged($event)"
    ></lm-html-url-doc>
</ng-template>

<ng-container *ngIf="bannerInRoute && isRouterOutletRootComponent; else ToolbarMarkup">
  <soho-header #SohoHeader [hasTabs]="false" [hasToolbar]="false">
    <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
  </soho-header>
</ng-container>

<div *ngIf="routeReuseMode && isRouterOutletRootComponent && lmContextService.isDeveloper()" class="font-size-px-16 route-reuse-indicator">Route Reuse Active</div>
<div soho-busyindicator
    *ngIf="(!legacyWebUI || uiCompare)"
    [ngClass]="{'scrollable' : isMingleInbox || isMingleOverlay || hideTitleManageScroll}"
    [style.height]="!isMingleOverlay ? '100%' : 'calc(100% - 50px)'"
    [text]="' '"
    [displayDelay]="0"
    [blockUI]="true"
    [transparentOverlay]="false"
    [timeToComplete]="this.uiLoadingIndicatorTimeout"
    [class.isMingleWidget]="isMingleWidget"
    [class.hide-title-or-mingle-inbox]="(isMingleInbox || isMingleOverlay || hideTitleManageScroll) && !isPageContextForm"
    [class.page-context-form]="!(isMingleInbox || isMingleOverlay || hideTitleManageScroll) && isPageContextForm"
>
  <ng-container *ngIf="emptyMessage !== null">
    <div soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
  </ng-container>

  <ng-template [ngIf]="(formViewData.formSpec && formViewData.dataView && emptyMessage === null) ">
    <div id='{{formSpec?.busFormSpec?.name}}' class="lmc" [class.lm-form-content-wrapper]="isCompositeForm || isActionFormWithSections">
      <ng-template [ngIf]="formViewData.dataView">
        <lm-form-content #LMFormContentComponent
            *ngIf="!hideLayout"
            [formUrlInfo]="formUrlInfo"
            [formSpec]="formViewData.formSpec"
            [formOptions]="formOptions"
            [specFields]="specFields"
            [layout]="layout"
            [model]="model"
            [placeHolder]="placeHolder"
            [formState]="formState"
            [formPersonalization]="formPersonalization"
            [fromDataView]="fromDataView"
            [columnarText]="columnarText"
            [parentIsModal]="parentIsModal"
            [instanceId]="instanceId"
            (searchButtonClicked)="onSearchClicked($event)"
            (clearSearchButtonClicked)="onClearSearchClicked($event)"
            (fieldEvent)="onFieldEvent($event)"
            (stepPanelEvent)="onStepPanelEvent($event)"
            (contentModified)="onContentModified($event)"
            (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (sendShortcutMessage)="onSendShortcutMessage($event)"
            (specialActionsToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
            (panelTransactionEvent)="onPanelTransactionEvent($event)"
            (drillAroundEvent)="onDrillAroundEvent($event)"
            (matrixActionEvent)="onRunMatrixActionEvent($event)"
            (contentLoadEvent)="onContentLoadEvent($event)"
            (startComponentTrackEvent)="onStartComponentTrackEvent($event)"
        ></lm-form-content>
      </ng-template>
    </div>
  </ng-template>
</div>
<ng-container *ngIf="isMingleOverlay && !isResponseRequired && !parentIsModal && !isStepProcessForm && !isSearchForm">
<div class="modal-buttonset" style="position:relative; width:100%;">
  <button id="PortalOverlay_Cancel"
    class="btn-modal no-ripple hide-focus"
    data-automation-id="lm-UpdateActionForm-modal-cancel"
    [style.width]="portalOverlayButtonWidth"
    (click)="onClickCancel()">
    <span>{{'Cancel' | translate}}</span>
  </button>
  <ng-container *ngIf="portalSaveAsDraftButton">
    <button id="PortalOverlay_SaveAsDraft"
      class="btn-modal no-ripple hide-focus"
      data-automation-id="lm-PortalOverlay-modal-cancel"
      [style.width]="portalOverlayButtonWidth"
      (click)="onPortalOverlayClickEvent(portalSaveAsDraftButton)">
      <span>{{'SaveAsDraft' | translate}}</span>
    </button>
  </ng-container>
  <ng-container *ngIf="portalScheduleButton">
    <button id="PortalOverlay_Schedule"
        class="btn-modal no-ripple hide-focus"
        data-automation-id="lm-PortalOverlay-modal-schedule"
        [style.width]="portalOverlayButtonWidth"
        (click)="onPortalOverlayClickEvent(portalScheduleButton)">
        <span>{{'Schedule' | translate}}</span>
    </button>
  </ng-container>
  <button
    id="PortalOverlay_Submit"
    class="btn-modal btn-modal-primary no-validation no-ripple hide-focus"
    data-automation-id="lm-PortalOverlay-modal-primary"
    [style.width]="portalOverlayButtonWidth"
    (click)="onPortalOverlayClickEvent(portalSubmitButton)">
    <span>{{portalSubmitButton?.actionReference?.label}}</span>
  </button>
</div>
</ng-container>

<div #dialogPlaceholder id="lmFormDialogPlaceholder" class="lmDialogPlaceholder"></div>

<ng-template #ToolbarMarkup>
  <!--  <ng-container *ngIf="hideTitleBar">   -->
    <div [class.header-border]="mingleInboxToolbar">
        <ng-container *ngIf="mingleInboxMultiToolbar; else LandmarkForm">
            <lm-toolbar
                [style.display]="mingleInboxMTHTML ? 'block' : 'none'"
                [inHeader]="false"
                [toolbarIdPrefix]="this.formSpec.busFormSpec.name + '_title'"
                [automationId]="this.formSpec.automationId + '-title'"
                [sectionTitle]="formTitle"
                [style.height]="mingleInboxMTHTML ? '42px' : ''"
                [style.align-content]="'center'"
                [class.hideTitleToolbar]="true"
                [class.banner-in-route]="true"
                (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
            ></lm-toolbar>
            <lm-toolbar
                #MingleFormToolbar
                [class.mingle-inbox-hide-title]="mingleInboxMTHTML"
                [inHeader]="isRouterOutletRootComponent && bannerInRoute"
                [toolbarIdPrefix]="this.formSpec.busFormSpec.name"
                [automationId]="this.formSpec.automationId"
                [sectionTitle]="showSectionTitleOnForm ? formTitle : ''"
                [buttons]="toolbarButtons | async"
                [moreMenuSettings]="toolbarMoreMenuSettings"
                [class.hideTitleToolbar]="true"
                [class.implements-cart-view]="formSpec.busFormSpec.implementsCartView"
                [class.banner-in-route]="true"

                (appMenuTriggerEvent)="onAppMenuTriggerEvent($event)"

                (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                (toolbarButtonEvent)="onToolbarButtonEvent($event)"
                (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
            ></lm-toolbar>
        </ng-container>
        <ng-template #LandmarkForm>
            <lm-toolbar *ngIf="formSpec && showToolbarOnForm && (!legacyWebUI || uiCompare)"
                #FormToolbar
                [inHeader]="isRouterOutletRootComponent && bannerInRoute"
                [toolbarIdPrefix]="this.formSpec.busFormSpec.name"
                [automationId]="this.formSpec.automationId"
                [sectionTitle]="showSectionTitleOnForm ? formTitle : ''"
                [buttons]="toolbarButtons | async"
                [moreMenuSettings]="toolbarMoreMenuSettings"
                [class.hideTitleToolbar]="true"
                [class.implements-cart-view]="formSpec.busFormSpec.implementsCartView"
                [class.banner-in-route]="true"

                (appMenuTriggerEvent)="onAppMenuTriggerEvent($event)"

                (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                (toolbarButtonEvent)="onToolbarButtonEvent($event)"
                (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
              ></lm-toolbar>
        </ng-template>
    </div>
  <!--  </ng-container>  -->
</ng-template>
